export default {
    getDListExternals: (state) => state.dListExternal,
  }